import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Research from "@/pages/Research";
import StoryDetail from "@/pages/StoryDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import About from "@/pages/About";
import Repository from "@/pages/Repository";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import WaterMission from "@/pages/WaterMission";
import { CopyProvider } from "@/lib/copy";
import AdminApp from "@/admin/AdminApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="admin/*" element={<AdminApp />} />
        <Route element={<CopyProvider><Layout /></CopyProvider>}>
          <Route index element={<Home />} />
          <Route path="research" element={<Research />} />
          <Route path="research/:slug" element={<StoryDetail />} />
          <Route path="events" element={<Events />} />
          <Route path="events/:slug" element={<EventDetail />} />
          <Route path="about" element={<About />} />
          <Route path="water-mission" element={<WaterMission />} />
          <Route path="repository" element={<Repository />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
